export default "__VITE_ASSET__CkMSX$nt__"